export default function buildTotalDaysMonthsText(seconds) {
  const days = (seconds / 60 / 60 / 24).toFixed(1);

  if (days <= 30) return `${days} days`;

  const months = (days / 30.44).toFixed(1);

  return `${months} months`;
}
